import {Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy} from '@angular/core';

import {Parcel} from 'src/app/_models/parcel';
import {ApiService} from 'src/app/_services/api.service';
import {NotifyService} from 'src/app/_services/notify.service';
import {GoogleAnalyticsService} from 'src/app/_services/GoogleAnalytics.service';
import {firstValueFrom} from 'rxjs';

@Component({
    selector: 'app-findProperty',
    templateUrl: './findProperty.component.html',
    styleUrls: ['./findProperty.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FindPropertyComponent implements OnInit {

  @Output() ParcelItem = new EventEmitter<Parcel>();
  @Input() color = '';
  @Input() title = '';
  @Input() imgItem = true;
  selector = false;
  ain: string;

  constructor(private apiService: ApiService, private notify: NotifyService, private google: GoogleAnalyticsService) {
  }

  ngOnInit(): void {
    // this.submit();
  }

  submit(): void {
    if (!this.ain) {
      this.notify.showNotification('error', 'AIN Field Empty! Try Again');
      return;
    }

    const ain = this.ain.replace(/\D/g, '');
    this.requestDataAsync(ain);
  }

  submitAddress(event: Parcel): void {
    const ain = event.AIN.replace(/\D/g, '');
    this.requestDataAsync(ain);
  }

  async requestDataAsync(ain: string): Promise<void> {
    const fullParcel = await firstValueFrom(this.apiService.getParcel(ain));

    if (!fullParcel) {
      this.notify.showNotification('error', 'Invalid AIN! Try Again');
      this.ain = '';
      return;
    }

    try {
      const mncStatus = await firstValueFrom(this.apiService.getMncStatus(ain));
      fullParcel.Parcel.MncClaimStatus = mncStatus.claimStatus;
      this.ParcelItem.emit(fullParcel.Parcel);
    } catch (e) {
      console.error(e);
      this.ParcelItem.emit(fullParcel.Parcel);
    }

    this.google.eventEmitter('Portal Search', fullParcel.Parcel.SitusCity, fullParcel.Parcel.AIN);
  }
}
